import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, ModalHeader, ModalBody, Row, Col, Button, ModalFooter } from 'reactstrap'

import './CustomModal.css'
import './CustomBigModal.css'

export const useModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen)
  }

  return { isModalOpen, toggleModal }
}

function CustomModal({ headerText, isOpen, toggle, children, big, backdrop, showCloseButton, boldHeader, medium }) {
  return (
    <Modal
      isOpen={isOpen}
      backdrop={backdrop}
      toggle={toggle}
      style={{ zIndex: '9999999' }}
      className={big ? 'CustomBigModal' : medium ? 'CustomMediumModal' : 'CustomModal'}
    >
      <ModalHeader>{boldHeader ? <strong>{headerText}</strong> : headerText}</ModalHeader>
      <ModalBody>
        <Row>
          <Col md='12'>{children}</Col>
        </Row>
      </ModalBody>
      {showCloseButton && (
        <ModalFooter>
          <Button onClick={toggle} color='danger' size='sm'>
            Close
          </Button>
        </ModalFooter>
      )}
    </Modal>
  )
}

CustomModal.propTypes = {
  headerText: PropTypes.string.isRequired,
  backdrop: PropTypes.bool,
  showCloseButton: PropTypes.bool,
}

CustomModal.defaultProps = {
  backdrop: true,
  showCloseButton: false,
}

export default CustomModal
